import {fromJson, json} from '../../../core/data-source/json.mapper';

export class HistoryRecord {
    @json({
        jsonName: 'user_name'
    })
    user: string;

    @json({
        jsonName: 'modification_date',
        mapper: {
            from: (val: string): string => val.substring(0, 16)
        }
    })
    date: string;

    @json({
        value: [],
        mapper: {
            from: (val: string): HistoryDescriptionRecord[] => {
                return val.split('~').map((part: string) => {
                    let pair: string[] = part.split('=');
                    return fromJson(HistoryDescriptionRecord, {
                        property: pair[0],
                        value: pair.length == 2 ? pair[1] : ''
                    });
                });
            }
        }
    })
    description: HistoryDescriptionRecord[];

    @json({
        jsonName: 'action_type'
    })
    action: number;
}

export class HistoryDescriptionRecord {
    @json() property: string;

    @json() value: string;
}
